import { render, staticRenderFns } from "./IntegrationFormWebhook.vue?vue&type=template&id=b69cdb9c&scoped=true"
import script from "./IntegrationFormWebhook.vue?vue&type=script&lang=js"
export * from "./IntegrationFormWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69cdb9c",
  null
  
)

export default component.exports